import type { components } from "../api/schema";
import type { TraceWaterfallSpan } from "../ui";

type StoredSpan = components["schemas"]["StoredSpan"];
type TraceNode = components["schemas"]["TraceNode"];
type TraceSpansResponse = components["schemas"]["TraceSpansResponse"];

export function traceNodeToWaterfallSpan(node: TraceNode): TraceWaterfallSpan {
  return {
    children: (node.children ?? []).map(traceNodeToWaterfallSpan),
    endMs: node.end_ms,
    id: node.span_id,
    name: node.name,
    startMs: node.start_ms,
  };
}

export function traceTreeToWaterfallSpans(
  tree: TraceNode[] | undefined,
): TraceWaterfallSpan[] {
  return (tree ?? []).map(traceNodeToWaterfallSpan);
}

export function traceNodeNamesById(
  tree: TraceNode[] | undefined,
): Record<string, string> {
  const names: Record<string, string> = {};
  for (const node of tree ?? []) {
    names[node.span_id] = node.name;
    Object.assign(names, traceNodeNamesById(node.children));
  }
  return names;
}

export function firstTraceId(trace: TraceSpansResponse): string | null {
  return trace.spans?.[0]?.trace_id ?? trace.tree?.[0]?.trace_id ?? null;
}

export function formatNanosecondsAsMs(value: number): string {
  if (!Number.isFinite(value)) {
    return "-";
  }
  const milliseconds = value / 1_000_000;
  if (milliseconds < 10) {
    return `${milliseconds.toFixed(3)} ms`;
  }
  if (milliseconds < 1000) {
    return `${milliseconds.toFixed(1)} ms`;
  }
  return `${(milliseconds / 1000).toFixed(2)} s`;
}

export function spanStatusTone(
  status: StoredSpan["status_code"],
): "danger" | "neutral" | "success" {
  if (status === "ERROR") {
    return "danger";
  }
  if (status === "OK") {
    return "success";
  }
  return "neutral";
}
